import React from "react";
import { NodeProps, useReactFlow } from "reactflow";
import styled from 'styled-components';
import { operationType } from "../../../../../services/types";
import { updateNodeValue } from "../../../../../services/method";
import { Textarea } from "../../../../form/textarea";
import { SettingsBlock, settingsDataType } from "../../../../settingsBlock";
import { IoCheckmarkCircleOutline, IoWarningOutline } from "react-icons/io5";
import { ExpandedBlock } from "../../../expanded";

type VideoVisionProps = NodeProps<operationType> & {
   setChildMinimize?: (fn: (id: string) => void) => void;
   setChildSettings?: (fn: (id: string) => void) => void;
};

export function VideoVision({ id, data, setChildMinimize, setChildSettings }: VideoVisionProps) {
   const { setNodes } = useReactFlow();
   const [settings, setSettings] = React.useState<settingsDataType>({ isToggle: false });
   const [isExpanded, setIsExpanded] = React.useState(false);
   
   // --
   React.useEffect(() => {
      if (setChildMinimize) setChildMinimize(() => { setIsExpanded(prev => !prev) });
      if (setChildSettings) setChildSettings(() => { setSettings(prev => ({ ...prev, isToggle: !prev.isToggle })) });
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [setChildMinimize, setChildSettings]);
   
   // ---
   const handleChangePrompt = (e: React.ChangeEvent<HTMLInputElement>) => {
      updateNodeValue(id, setNodes, { text_prompt: e.target.value });
   }

   // ---
   const isWarning = false;

   return (<>
      <SettingsBlock nodeId={ id }data={ settings } setData={ setSettings } />
      <Main>
         {isWarning ? <>
            <div id="warning"></div>
            <span id="warningIcon"><IoWarningOutline size={21} /></span>
         </> : data.output ? <>
            <div id="ran"></div>
            <span id="ranIcon"><IoCheckmarkCircleOutline size={21} /></span>
         </> : null}
         { isExpanded ? <ExpandedBlock
            data={{ id, ...data }} 
            handleClose={ () => setIsExpanded(false) } 
            isWarning={ isWarning }
            style={{ width: '400px' }}
         ><Styled>
            <Textarea
               value={ data.value?.text_prompt } 
               placeholder="Text Prompt" 
               handleChange={ handleChangePrompt } 
         />
         </Styled></ExpandedBlock> : null}
      </Main>
   </>);
}

// ---
const Main = styled.div`
   min-width: 150px;
   padding: 0;
`;

const Styled = styled.div`
   .textarea { 
      width: 100%;
   }
`;